import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _BookOpenLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", d: "M5 18h4a3 3 0 0 1 3 3V11c0-2.828 0-4.243-.879-5.121C10.243 5 8.828 5 6 5H5c-.943 0-1.414 0-1.707.293S3 6.057 3 7v9c0 .943 0 1.414.293 1.707S4.057 18 5 18ZM19 18h-4a3 3 0 0 0-3 3V11c0-2.828 0-4.243.879-5.121C13.757 5 15.172 5 18 5h1c.943 0 1.414 0 1.707.293S21 6.057 21 7v9c0 .943 0 1.414-.293 1.707S19.943 18 19 18Z" }) }) });
}
const BookOpenLight = forwardRef(_BookOpenLight);
export { BookOpenLight };
